// extracted by mini-css-extract-plugin
module.exports = {"headingVideoSection":"fZi-Y","heading":"_21aPl","video":"_1F7qi","headingParagraphContainer":"_1VlLa","videoContainer":"_36_p2","newToBrickX":"WdmmA","newToBrickX--arrow":"_2cjLb"};